import styled from "styled-components";
// 본문 섹션 제목 (페이지 상단 비주얼은 PageTemplate이 그린다)
// 기존 호출부 호환을 위해 noImage 등 props는 받기만 한다
const TitleTemplate = ({ title, subHeader }) => {
  return (
    <Div>
      <span className="bar" aria-hidden="true" />
      <h2>{title}</h2>
      {subHeader && <p>{subHeader}</p>}
    </Div>
  );
};

export default TitleTemplate;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: clamp(4rem, 7vw, 6rem) 0 clamp(2rem, 3.5vw, 3rem);
  & > .bar {
    width: 2.5rem;
    height: 4px;
    border-radius: 4px;
    background: linear-gradient(90deg, ${({ theme }) => theme.colors.accent}, ${({ theme }) => theme.colors.dark});
    margin-bottom: 1.25rem;
  }
  & > h2 {
    margin: 0;
    font-size: clamp(1.6rem, 3vw, 2.25rem);
    line-height: 1.3;
    font-weight: 800;
    letter-spacing: -0.03em;
    color: ${({ theme }) => theme.colors.dark};
  }
  & > p {
    margin: 0.85rem 0 0;
    max-width: 44rem;
    font-size: clamp(1rem, 1.5vw, 1.125rem);
    color: ${({ theme }) => theme.colors.foreground.dimmed};
  }
`;
